import createReducer from '../utils/createReducer';
import ActionTypes from '../constants/ActionTypes';
import { combineReducers } from 'redux';

const list = createReducer(
  {},
  {
    [ActionTypes.FETCH_LOCATION_SUCCESS]: (state, { payload }) => payload
  }
);

const setStatusForId = (state, { type, payload }) =>
  Object.assign({}, state, { [payload.id]: type });

const status = createReducer(
  {},
  {
    [ActionTypes.FETCH_LOCATION_SUCCESS]: setStatusForId,
    [ActionTypes.FETCH_LOCATION_ERROR]: setStatusForId
  }
);

const setPostcode = (state, { payload }) => {
  return Object.assign({}, { code: payload });
};
const setPostcodeError = (state, { payload, type }) =>
  Object.assign({}, state, { [payload]: type });
const postcode = createReducer(
  {},
  {
    [ActionTypes.FETCH_LOCATION_TO_POSTCODE_SUCCESS]: setPostcode,
    [ActionTypes.FETCH_LOCATION_TO_POSTCODE_ERROR]: setPostcodeError
  }
);

export default combineReducers({
  list,
  postcode,
  status
});
